import http from "@/services/http";

/**
 * Busca o perfil do paciente (tabela patient_profiles). Pode ser null se ainda
 * não houver perfil registrado.
 *
 * @param {number|string} patientId
 * @returns {Promise<object|null>}
 */
export async function getProfileByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-profile/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || null : null;
}

/**
 * Salva (upsert) o perfil do paciente.
 * @param {number|string} patientId
 * @param {object} payload { blood_type?, denies_chronic_disease? }
 */
export function saveProfile(patientId, payload) {
  return http.post("/api/patient-profile/save", {
    patient_id: patientId,
    ...payload,
  });
}
